"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.Count=void 0;const Count=exports.Count=_styledComponents.default.div`
font-size: 20px;
font-style: normal;
font-weight: 600;
line-height: 24px; 
    color: #2A292B;


`;